export default __webpack_public_path__ + "i18n/it.077a1942d40d48c96976c81be7d8cae2.json";